import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { authAPI } from '../../services/(adminapi)/authAPI'
import { clearAuth } from '../../store/slices/authSlice'

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch()
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth)
  const [isValidating, setIsValidating] = useState(false)
  
  useEffect(() => {
    const validateSession = async () => {
      const sessionToken = localStorage.getItem('sessionToken')
      const token = localStorage.getItem('token')
      
      // Only validate if we have sessionToken but token might be expired
      if (sessionToken && token) {
        setIsValidating(true)
        try {
          const response = await authAPI.validateSession(sessionToken)
          if (!response.data.valid) {
            // Session expired, clear auth and redirect
            dispatch(clearAuth())
          }
        } catch (error) {
          // Session validation failed, clear auth
          dispatch(clearAuth())
        } finally {
          setIsValidating(false)
        }
      } else if (!sessionToken && !token) {
        // No session at all, ensure auth is cleared
        dispatch(clearAuth())
      }
    }
    
    validateSession()
  }, [dispatch])

  if (isLoading || isValidating) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#64748b'
      }}>
        Loading...
      </div>
    )
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/signin" replace />
}

export default ProtectedRoute